// extracted by mini-css-extract-plugin
export default {"section":"DashboardSection_section__8M7SA","header":"DashboardSection_header__Kr983"};